exports.ByName = {
  HasValueAdded: { Id: 1, Name: 'HasValueAdded', IsBulk: true },
  OperatingIncomeMissing1Years: { Id: 2, Name: 'OperatingIncomeMissing1Year', IsBulk: true },
  OperatingIncomeMissing2Years: { Id: 3, Name: 'OperatingIncomeMissing2Year', IsBulk: true },
  NetSalesMissing1Year: { Id: 4, Name: 'NetSalesMissing1Year', IsBulk: true },
  NetSalesMissing2Year: { Id: 5, Name: 'NetSalesMissing2Year', IsBulk: true },
  NetSalesLessHalfMillion: { Id: 6, Name: 'NetSalesLessHalfMillion', IsBulk: true },
  NetSalesLess1Million: { Id: 7, Name: 'NetSalesLess1Million', IsBulk: true },
  NetSalesLess10Million: { Id: 8, Name: 'NetSalesLess10Million', IsBulk: true },
  AdvertisingExpenseOverTotalNetSalesGreater3: { Id: 9, Name: 'AdvertisingExpenseOverTotalNetSalesGreater3', IsBulk: true },
  AdvertisingExpenseOverTotalNetSalesGreater5: { Id: 10, Name: 'AdvertisingExpenseOverTotalNetSalesGreater5', IsBulk: true },
  RndExpenseOverTotalNetSalesGreater3: { Id: 11, Name: 'RndExpenseOverTotalNetSalesGreater3', IsBulk: true },
  RndExpenseOverTotalNetSalesGreater5: { Id: 12, Name: 'RndExpenseOverTotalNetSalesGreater5', IsBulk: true },
  AvgPpeOverAvgOperatingAssetsGreater25: { Id: 13, Name: 'AvgPpeOverAvgOperatingAssetsGreater25', IsBulk: true },
  LatestFyeAvailable: { Id: 14, Name: 'LatestFyeAvailable', IsBulk: true },
  ParentOwnershipGreater25: { Id: 15, Name: 'ParentOwnershipGreater25', IsBulk: true },
  SubsNoConsolidated: { Id: 16, Name: 'SubsNoConsolidated', IsBulk: true },
  FineTuning: { Id: 17, Name: 'FineTuning', IsBulk: false },
  Discard: { Id: 18, Name: 'Discard', IsBulk: true },
  ParentOwnershipGreater50: { Id: 19, Name: 'ParentOwnershipGreater50', IsBulk: true },
  ParentOwnershipLesser50: { Id: 20, Name: 'ParentOwnershipLesser50', IsBulk: true },
  AvgOperatingIncomeLess0: { Id: 21, Name: 'AvgOperatingIncomeLess0', IsBulk: true },
  IsPrimarilyRetailer: { Id: 22, Name: 'IsPrimarilyRetailer', IsBulk: false },
  EngagesInSignificantManufacturing: { Id: 23, Name: 'EngagesInSignificantManufacturing', IsBulk: false },
  IsPrimarilyAServiceProvider: { Id: 24, Name: 'IsPrimarilyAServiceProvider', IsBulk: false },
  OwnsValuableIntangibles: { Id: 25, Name: 'OwnsValuableIntangibles', IsBulk: false },
  IsANonProfit: { Id: 26, Name: 'IsANonProfit', IsBulk: false },
  InsufficientCompanyInformation: { Id: 27, Name: 'InsufficientCompanyInformation', IsBulk: false },
  InsufficientFinancial: { Id: 28, Name: 'InsufficientFinancial', IsBulk: false },
  EngagesInDissimilarActivities: { Id: 29, Name: 'EngagesInDissimilarActivities', IsBulk: false },
  NoWebsite: { Id: 30, Name: 'NoWebsite', IsBulk: false },
  Manufacturer: { Id: 31, Name: 'Manufacturer', IsBulk: false },
  OtherMisclassified: { Id: 32, Name: 'OtherMisclassified', IsBulk: false },
  OutOfBusiness: { Id: 33, Name: 'OutOfBusiness', IsBulk: false },
  Franchise: { Id: 34, Name: 'Franchise', IsBulk: false },
  NonProfit: { Id: 35, Name: 'NonProfit', IsBulk: false },
  InsufficientInfo: { Id: 36, Name: 'InsufficientInfo', IsBulk: false },
  ToDiverse: { Id: 37, Name: 'ToDiverse', IsBulk: false },
  SellsProprietarySoftware: { Id: 38, Name: 'SellsProprietarySoftware', IsBulk: false },
  OperatesAsAConsortium: { Id: 40, Name: 'OperatesAsAConsortium', IsBulk: false },
  PublicComps: { Id: 41, Name: 'PublicComps', IsBulk: false },
  PrivateComps: { Id: 42, Name: 'PrivateComps', IsBulk: false },
  OperatingIncomeMissing3Year: { Id: 43, Name: 'OperatingIncomeMissing3Year', IsBulk: false },
  TotalNetSalesMissing3Year: { Id: 44, Name: 'TotalNetSalesMissing3Year', IsBulk: false },
  DoesNotHaveValueAdded: { Id: 45, Name: 'DoesNotHaveValueAdded', IsBulk: true },
  GrossMargin: { Id: 46, Name: 'GrossMargin', IsBulk: true },
  BerryRatio: { Id: 47, Name: 'BerryRatio', IsBulk: true },
  OperatingMargin: { Id: 48, Name: 'GrossMargin', IsBulk: true },
  ReturnOnOperatingAssets: { Id: 49, Name: 'GrossMargin', IsBulk: true },
  CostPlus: { Id: 50, Name: 'CostPlus', IsBulk: true },
  NetCostPlus: { Id: 51, Name: 'NetCostPlus', IsBulk: true },
  Other: { Id: 52, Name: 'Other', IsBulk: false },
  NetSalesLesserThan5Million: { Id: 53, Name: 'NetSalesLesserThan5Million', IsBulk: true },
  NetSalesLesserThan10Million: { Id: 54, Name: 'NetSalesLesserThan10Million', IsBulk: true },
  NetSalesLesserThan25Million: { Id: 55, Name: 'NetSalesLesserThan25Million', IsBulk: true },
  NetSalesLesserThan50Million: { Id: 56, Name: 'NetSalesLesserThan50Million', IsBulk: true },
  NetSalesLesserThan100Million: { Id: 57, Name: 'NetSalesLesserThan100Million', IsBulk: true },
  NetSalesLesserThan1Million: { Id: 58, Name: 'NetSalesLesserThan1Million', IsBulk: true },
  OperatingIncomeNegative1Year: { Id: 59, Name: 'OperatingIncomeNegative1Year', IsBulk: true },
  OperatingIncomeNegative2Year: { Id: 60, Name: 'OperatingIncomeNegative2Year', IsBulk: true },
  OperatingIncomeNegative3Year: { Id: 61, Name: 'OperatingIncomeNegative3Year', IsBulk: true },
  CompanyHasSubsidiaries: { Id: 62, Name: 'CompanyHasSubsidiaries', IsBulk: true },
  CompanyHasUnconsolidatedFinancials: { Id: 63, Name: 'CompanyHasUnconsolidatedFinancials', IsBulk: true },
  NetSalesGreaterThan1Million: { Id: 64, Name: 'NetSalesGreaterThan1Million', IsBulk: true },
  NetSalesGreaterThan5Million: { Id: 65, Name: 'NetSalesGreaterThan5Million', IsBulk: true },
  NetSalesGreaterThan10Million: { Id: 66, Name: 'NetSalesGreaterThan10Million', IsBulk: true },
  NetSalesGreaterThan25Million: { Id: 67, Name: 'NetSalesGreaterThan25Million', IsBulk: true },
  NetSalesGreaterThan50Million: { Id: 68, Name: 'NetSalesGreaterThan50Million', IsBulk: true },
  NetSalesGreaterThan100Million: { Id: 69, Name: 'NetSalesGreaterThan100Million', IsBulk: true }
};

exports.ById = {
  1: { Id: 1, Name: 'HasValueAdded', IsBulk: true },
  2: { Id: 2, Name: 'OperatingIncomeMissing1Year', IsBulk: true },
  3: { Id: 3, Name: 'OperatingIncomeMissing2Year', IsBulk: true },
  4: { Id: 4, Name: 'NetSalesMissing1Year', IsBulk: true },
  5: { Id: 5, Name: 'NetSalesMissing2Year', IsBulk: true },
  6: { Id: 6, Name: 'NetSalesLessHalfMillion', IsBulk: true },
  7: { Id: 7, Name: 'NetSalesLess1Million', IsBulk: true },
  8: { Id: 8, Name: 'NetSalesLess10Million', IsBulk: true },
  9: { Id: 9, Name: 'AdvertisingExpenseOverTotalNetSalesGreater3', IsBulk: true },
  10: { Id: 10, Name: 'AdvertisingExpenseOverTotalNetSalesGreater5', IsBulk: true },
  11: { Id: 11, Name: 'RndExpenseOverTotalNetSalesGreater3', IsBulk: true },
  12: { Id: 12, Name: 'RndExpenseOverTotalNetSalesGreater5', IsBulk: true },
  13: { Id: 13, Name: 'AvgPpeOverAvgOperatingAssetsGreater25', IsBulk: true },
  14: { Id: 14, Name: 'LatestFyeAvailable', IsBulk: true },
  15: { Id: 15, Name: 'ParentOwnershipGreater25', IsBulk: true },
  16: { Id: 16, Name: 'SubsNoConsolidated', IsBulk: true },
  17: { Id: 17, Name: 'FineTuning', IsBulk: false },
  18: { Id: 18, Name: 'Discard', IsBulk: true },
  19: { Id: 19, Name: 'ParentOwnershipGreater50', IsBulk: true },
  20: { Id: 20, Name: 'ParentOwnershipLesser50', IsBulk: true },
  21: { Id: 21, Name: 'AvgOperatingIncomeLess0', IsBulk: true },

  22: { Id: 22, Name: 'IsPrimarilyRetailer', IsBulk: false },
  23: { Id: 23, Name: 'EngagesInSignificantManufacturing', IsBulk: false },
  24: { Id: 24, Name: 'IsPrimarilyAServiceProvider', IsBulk: false },
  25: { Id: 25, Name: 'OwnsValuableIntangibles', IsBulk: false },
  26: { Id: 26, Name: 'IsANonProfit', IsBulk: false },
  27: { Id: 27, Name: 'InsufficientCompanyInformation', IsBulk: false },
  28: { Id: 28, Name: 'InsufficientFinancial', IsBulk: false },
  29: { Id: 29, Name: 'EngagesInDissimilarActivities', IsBulk: false },
  30: { Id: 30, Name: 'NoWebsite', IsBulk: false },
  31: { Id: 31, Name: 'Manufacturer', IsBulk: false },
  32: { Id: 32, Name: 'OtherMisclassified', IsBulk: false },
  33: { Id: 33, Name: 'OutOfBusiness', IsBulk: false },
  34: { Id: 34, Name: 'Franchise', IsBulk: false },
  35: { Id: 35, Name: 'NonProfit', IsBulk: false },
  36: { Id: 36, Name: 'InsufficientInfo', IsBulk: false },
  37: { Id: 37, Name: 'ToDiverse', IsBulk: false },
  38: { Id: 38, Name: 'SellsProprietarySoftware', IsBulk: false },
  40: { Id: 40, Name: 'OperatesAsAConsortium', IsBulk: false },
  41: { Id: 41, Name: 'PublicComps', IsBulk: false },
  42: { Id: 42, Name: 'PrivateComps', IsBulk: false },
  43: { Id: 43, Name: 'OperatingIncomeMissing3Year', IsBulk: false },
  44: { Id: 44, Name: 'TotalNetSalesMissing3Year', IsBulk: false },
  45: { Id: 45, Name: 'DoesNotHaveValueAdded', IsBulk: true },
  46: { Id: 46, Name: 'GrossMargin', IsBulk: true },
  47: { Id: 47, Name: 'BerryRatio', IsBulk: true },
  48: { Id: 48, Name: 'OperatingMargin', IsBulk: true },
  49: { Id: 49, Name: 'ReturnOnOperatingAssets', IsBulk: true },
  50: { Id: 50, Name: 'CostPlus', IsBulk: true },
  51: { Id: 51, Name: 'NetCostPlus', IsBulk: true },
  52: { Id: 52, Name: 'Other', IsBulk: false },
  53: { Id: 53, Name: 'NetSalesLesserThan5Million', IsBulk: true },
  54: { Id: 54, Name: 'NetSalesLesserThan10Million', IsBulk: true },
  55: { Id: 55, Name: 'NetSalesLesserThan25Million', IsBulk: true },
  56: { Id: 56, Name: 'NetSalesLesserThan50Million', IsBulk: true },
  57: { Id: 57, Name: 'NetSalesLesserThan100Million', IsBulk: true },
  58: { Id: 58, Name: 'NetSalesLesserThan1Million', IsBulk: true },
  59: { Id: 59, Name: 'OperatingIncomeNegative1Year', IsBulk: true },
  60: { Id: 60, Name: 'OperatingIncomeNegative2Year', IsBulk: true },
  61: { Id: 61, Name: 'OperatingIncomeNegative3Year', IsBulk: true },
  62: { Id: 62, Name: 'CompanyHasSubsidiaries', IsBulk: true },
  63: { Id: 63, Name: 'CompanyHasUnconsolidatedFinancials', IsBulk: true },
  64: { Id: 64, Name: 'NetSalesGreaterThan1Million', IsBulk: true },
  65: { Id: 65, Name: 'NetSalesGreaterThan5Million', IsBulk: true },
  66: { Id: 66, Name: 'NetSalesGreaterThan10Million', IsBulk: true },
  67: { Id: 67, Name: 'NetSalesGreaterThan25Million', IsBulk: true },
  68: { Id: 68, Name: 'NetSalesGreaterThan50Million', IsBulk: true },
  69: { Id: 69, Name: 'NetSalesGreaterThan100Million', IsBulk: true }
};

exports.Default = { Id: 0, Name: 'None' };
